import React from 'react';
import { Icon, Link, SxProps, Theme, Typography } from '@mui/material';
import ArrowRightIcon from '../CustomSVGIcons/ArrowRightIcon';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

export interface IGoHomeButton {
    sx?: SxProps<Theme>;
    text?: string;
    isBg?: boolean;
}
export const GoHomeButton: React.FC<IGoHomeButton> = ({ sx, text = 'Go Home', isBg }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Link
            href="/feed"
            sx={{
                '&:hover': { cursor: 'pointer' },
                textDecoration: 'none',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                ...sx,
            }}>
            <Typography
                style={{
                    color: isBg ? theme[themeStyle].true_white : theme[themeStyle].tag_white,
                    marginRight: 8,
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                }}
                sx={{ fontSize: { xs: '14px', sm: '16px' } }}>
                {text}
            </Typography>
            <Icon
                sx={{
                    width: { xs: '18px', sm: '24px' },
                    height: { xs: '18px', sm: '24px' },
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                }}>
                <ArrowRightIcon fill={isBg ? theme[themeStyle].true_white : theme[themeStyle].tag_white} />
            </Icon>
        </Link>
    );
};
